import apiInstance from "api";

const CartApiService = {
  createCart: async (body = {}) => {
    return await apiInstance.post("/products/carts", body);
  },

  getCart: async (cartId) => {
    return await apiInstance.get(`/products/carts/${cartId}`);
  },

  addToCart: async (cartId, body) => {
    return await apiInstance.post(`/products/carts/${cartId}/items`, body);
  },

  updateCart: async (cartId, body) => {
    return await apiInstance.put(`/products/carts/${cartId}/items`, body);
  },

  removeProductFromCart: async (cartId, productId, action = "q") => {
    return await apiInstance.delete(
      `/products/carts/${cartId}/items/${productId}?action=${action}`
    );
  },
};

export default CartApiService;
